import { RiskLevel } from '@models/assessment';

import { Gender } from 'generated/types';

import type { ReferenceRange } from './types';

const referenceRange: ReferenceRange<RiskLevel> = new Map([
  [
    Gender.unknown,
    new Map([
      [RiskLevel.Low, [{ lower: 0, upper: 25 }]],
      [RiskLevel.Medium, [{ lower: 25, upper: 50 }]],
      [RiskLevel.High, [{ lower: 50, upper: 100 }]],
    ]),
  ],
]);

export default referenceRange;
